import { getFigureOrigin } from '@figure/figure-frontlib-gui';
import { IS_PROD } from './environment';

export const FIGURE_ORIGIN = getFigureOrigin(IS_PROD);
